<template>
    <tr class="clickable-row">
            <td>
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" >
                    {{Utils.getShortDateStringFromISO(feeLog.purchase_date_day)}}
                </router-link>
            </td>
            <td>
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" >
                    <span v-if="feeLogCreator">{{StringsHelper.getCreatorSimple(feeLogCreator.id)}}</span> <span v-else>Tutti</span>
                </router-link>
            </td>
            <td>
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" >
                    <span v-if="feeLogPaymentMode">{{StringsHelper.getPaymentModeSimple(feeLogPaymentMode)}}</span> <span v-else>Tutti</span>
                </router-link>
            </td>
            <td>
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" >
                    <span v-if="feeLogDocumentType">{{StringsHelper.getDocumentType(feeLogDocumentType)}}</span> <span v-else>Tutti</span>
                </router-link>
            </td>
            <td class="text-right" >
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" class="bold">
                    €{{parseFloat(feeLog.price_final).toFixed(2)}}
                </router-link>
            </td>
            <td class="text-right" >
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}" >
                    €{{getFee()}}
                </router-link>
            </td>
            <td class="text-right" >
                <router-link target= '_blank' :to="{name:'transactions_date', query: {transaction_date: feeLog.purchase_date_day}}"
                >€{{parseFloat(feeLog.price_net).toFixed(2)}}
                </router-link>
            </td>
    </tr>
</template>

<script>
    
    import baseMixin from '@/common/baseMixin'

    export default {
        name: "FeeLogRow",
        mixins: [baseMixin],
        props: {
            feeLog: {
                type: Object,
                required: true
            },
            feeLogCreator:{
                type: Object
            },
            feeLogPaymentMode:{
                type: Number
            },
            feeLogDocumentType:{
                type: Number
            },
        },
        methods:{
            getFee(){
                let n = this.feeLog.price_final - this.feeLog.price_net
                return n.toFixed(2)
            }
        }
    }
</script>
